import { debug } from 'util';
import { AuthService } from './../user/auth.service';
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { RegistryFirebaseService } from './registry-firebase.service';
import { Registry } from './registry';

@Injectable()
export class RegistryResolve implements Resolve<any> {

  constructor(
    private _registryFirebaseService: RegistryFirebaseService,
    private _authService: AuthService,
    private router: Router
  ) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Registry> {
    const pageUserMode = route.data.pageUserMode;
    const isBanners = route.outlet === 'banners' && location.pathname.toLowerCase().endsWith('/registry');
    const isBannersButNotRegPage = route.outlet === 'banners' && !location.pathname.toLowerCase().endsWith('/registry');
    const registryName = route.paramMap.get('registry') ? route.paramMap.get('registry') : route.parent.paramMap.get('registry');
    ;
    const registry = this._registryFirebaseService.registry;

 const isAnon = route.queryParams.anon;

 if(isAnon || location.pathname.includes('/your-registry')){
  return Observable.of(this._registryFirebaseService.getAnonRegistry());
 }


    if (  (route.routeConfig.path && route.routeConfig.path.toLowerCase() === 'login')) {
      return Observable.of(null);
    }

    if (isBannersButNotRegPage && registryName) {
      return Observable.of(null);
    }


    if (registry && registryName && registryName.toLowerCase() === registry.registryName.toLowerCase()) {
      if (pageUserMode !== 'couple') {
        this._authService.user.subscribe(user => {
          this._registryFirebaseService.initLoadingReg(registry, this.router, user);
        });

      }
      return Observable.of(registry);
    } else {


      if (pageUserMode === 'couple') {
        return this._registryFirebaseService.regforUser().take(1);
      } else if (isBanners) {
        return this._registryFirebaseService.regforUser().take(1);
      } else if (registry){
        return Observable.of(registry);
      } 
      else if (registryName) {

        return this._registryFirebaseService.registryByName(registryName).take(1);

        // });
      }
    }


  }
}



// WEBPACK FOOTER //
// ./src/app/registry/registry.resolve.ts